import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import {getUnique} from 'helpers/array-helper';
import Const from 'const';

class OneTheSameTeamWasChosenForBothStacksValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const checkedTeamNamesOfPrimaryStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.MLB_NON_CONTROLLED_FIRST_GROUP,
        );
        const checkedTeamNamesOfSecondaryStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.MLB_NON_CONTROLLED_SECOND_GROUP,
        );

        const uniqueTeamNames = getUnique([...checkedTeamNamesOfPrimaryStack, ...checkedTeamNamesOfSecondaryStack]);

        const minUniqueTeamsQuantity = 2;
        if (minUniqueTeamsQuantity > uniqueTeamNames.length) {
            this.addError('The only one and same team for both stacks is not allowed.');
        }
    }
}

export default OneTheSameTeamWasChosenForBothStacksValidator;
